<script lang="ts">
    interface Props {
        size?: "sm" | "md" | "lg";
        class?: string;
    }

    let { size = "md", class: className = "" }: Props = $props();

    const sizeClasses = {
        sm: "h-3 w-3",
        md: "h-4 w-4",
        lg: "h-5 w-5",
    };
</script>

<div class="border-primary animate-spin rounded-full border-2 border-t-transparent {sizeClasses[size]} {className}"
></div>
